// Generated by CoffeeScript 2.7.0
var CarbonCopyAssignmentSetting;

import UserSearch from 'trunks/vue/admin/components/search/user.js';

export default CarbonCopyAssignmentSetting = {
  components: {
    'user-search': UserSearch
  },
  data: function() {
    return {
      user_ids: []
    };
  },
  template: `<div class="form-field inline">
  <div class="form-field-head">
    <div class="form-field-title">抄送给</div>
  </div>
  <div class="form-field-input-container">
    <div class="form-field-input">
      <user-search ref='users'
                   placeholder='请输入'
                   :remote='remoteUsersUrl'
                   @valueChanged='updateUsers'
                   :selectedUserIds='user_ids'
                   popoverPosition='bottom' />
    </div>
  </div>
</div>`,
  created: function() {
    return this.remoteUsersUrl = Skylark.Helpers.UrlHelper.namespaceUrlFor('/users/query', {
      exclude_self: true
    });
  },
  methods: {
    updateUsers: function(vm) {
      return this.user_ids = _.pluck(vm.selectedItems, 'id');
    },
    getData: function() {
      return this.user_ids;
    }
  }
};
